module.exports = [
  require('./power_word_pain'),
  require('./primal_savagery'),
  require('./primordial_ward'),
  require('./psychic_scream'),
  require('./pyrotechnics'),
]
